import { type ReactElement, type RefObject, ReactNode } from 'react';
import { CallControlBarContainer } from './callControlBarContainer';

export const CONTROL_BAR_HEIGHT = 48;

export type CallControlBarProps = {
  controlBarRef?: RefObject<HTMLDivElement | null>;
  children?: ReactNode;
};

export const CallControlBar = ({
  controlBarRef,
  children,
}: CallControlBarProps): ReactElement => {
  return (
    <CallControlBarContainer controlBarRef={controlBarRef}>
      {children}
    </CallControlBarContainer>
  );
};
